import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { homeFor } from '../auth/gate';
import { AuthFrame } from '../screens/auth/AuthFrame';
import { SignInPage } from '../screens/auth/SignInPage';

const searchSchema = z.object({
  /** Where to go after signing in; app-relative only. */
  next: z
    .string()
    .regex(/^\/(?!\/)/)
    .optional(),
});

/**
 * The sign-in concept (concept 34: the object in its volume, the glass, the cables), kept as a
 * page that can still be seen and signed in on; the product's own sign-in is /sign-in, on
 * CapturePoint's ground (Dustin, 2026-09-20).
 */
export const Route = createFileRoute('/sign-in_/concept')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context }) => {
    const principal = await context.auth.ensureOrNone();
    if (principal) throw redirect(homeFor(principal));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { next } = Route.useSearch();
  return <SignInPage next={next ?? '/'} Frame={AuthFrame} />;
}
